import { render } from "./FanContent.vue?vue&type=template&id=37f85116&scoped=true"
import script from "./FanContent.vue?vue&type=script&lang=js"
export * from "./FanContent.vue?vue&type=script&lang=js"

import "./FanContent.vue?vue&type=style&index=0&id=37f85116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f85116"]])

export default __exports__